import React, { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useAuthentication } from '@/features/auth/useAuthentication';

const EntityLayout: React.FC = () => {
  const { entityId } = useParams<{ entityId: string }>();
  const { loggedUser, authenticationDone, checkAuthentication, hasSalonAccess, isGlobalAdmin } = useAuthentication();

  useEffect(() => {
    if (!authenticationDone) {
      checkAuthentication();
    }
  }, [authenticationDone, checkAuthentication]);

  if (!authenticationDone) {
    return null;
  }

  if (!loggedUser) {
    return null; // AppLayout's AuthenticationNeeded already redirects to login.
  }

  // Platform admin sees every salon. Other users only their own.
  if (!isGlobalAdmin() && entityId && !hasSalonAccess(entityId)) {
    return (
      <div className="flex-1 flex items-center justify-center p-12 bg-gray-50">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 max-w-md text-center">
          <h2 className="text-lg font-semibold text-gray-900 mb-2">Nemáte přístup k tomuto salonu</h2>
          <p className="text-sm text-gray-600">
            Tento salon spravuje jiný účet. Pokud potřebujete přístup, kontaktujte správce salonu.
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default EntityLayout;
